import { buildHeaders } from "../buildHeaders";
import { smartAxios } from "../axios/Axios";
import { REST_API_URL } from "../config";
import { paymentEndpoints } from "./paymentEndpoints";

  // export const getPaymentCheck = async () => {
  //     const PAYMENT_CHECK_URL = `${REST_API_URL}${paymentEndpoints.getPaymentCheck}`;
  //   try {
  //     const token =
  //       localStorage.getItem("accessToken") ||
  //       sessionStorage.getItem("accessToken");

  //     const headers = buildHeaders();
    
  //     const res = await fetch(PAYMENT_CHECK_URL, {
  //       headers,
  //     });

  //     const data = await res.json();
  //     return data;
  //   } catch (e: any) {
  //     console.log("Failed to load payment check", e);
  //       return e.message || "Failed to load payment check";
  //   }  
  // };

  export const getPaymentPlans = () => {
    return smartAxios.get(paymentEndpoints.getPaymentPlans)
}
export const getPaymentCheck = () => {
    return smartAxios.get(paymentEndpoints.getPaymentCheck)
}
export const getZiinaUser = () => {
    return smartAxios.get(paymentEndpoints.getZiinaUser)
}
export const postValidateReceipt = (receipt: any) => {
    return smartAxios.post(paymentEndpoints.postValidateReceipt, {
        receipt,
    })
}

export const postStripeCheckCoupon = (code: string) => {
    return smartAxios.post(paymentEndpoints.postStripeCheckCoupon, {
        code,
    })
}

export const postGoogleReceipt = (receipt: any) => {
    return smartAxios.post(paymentEndpoints.postGoogleReceipt, {
        receipt,
    })
}